<div class="session-ended-dialog">
  <div class="dialog-icon-container">
    <span class="dialog-icon warning">
      <mat-icon>{{ data.iconName }}</mat-icon>
    </span>
  </div>
  
  <h2 mat-dialog-title class="dialog-title">{{ data.title }}</h2>
  
  <mat-dialog-content class="dialog-content">
    <p class="dialog-message">{{ data.message }}</p>
  </mat-dialog-content>
  
  <mat-dialog-actions class="dialog-actions" align="center">
    <button mat-stroked-button 
            (click)="onClose()" 
            class="close-button">
      {{ data.closeButtonText }}
    </button>
    
    @if (data.showRestartOption) {
      <button mat-flat-button 
              color="primary"
              (click)="onRestart()" 
              class="restart-button">
        {{ data.restartButtonText }}
      </button>
    }
  </mat-dialog-actions>
</div>
